export const LIMITLESS_BALANCE_TEXT = "Unlimited";
